import { Component } from 'react';
import _ from 'lodash';

class baseFilter extends Component {

    get_agg_values(response) {

        const resp_agg = {};

        if (!response || !response.meta || !response.meta.agg) {
            return resp_agg;
        }

        for (const agg_field in this.aggregates) {

            const agg_type = this.aggregates[agg_field];

            const api_agg = _.get(
                response.meta.agg,
                agg_field
            );

            if (_.isUndefined(api_agg) || api_agg === null) {
                resp_agg[agg_field] = {};
                continue;
            }

            /*
             * Backend returns:
             *
             * {
             *   "sample.cancer_type.name": {
             *      "count": {
             *          "Lung": 10,
             *          "Breast": 20
             *      }
             *   }
             * }
             *
             * Keep that structure intact.
             */

            if (_.has(api_agg, agg_type)) {
                resp_agg[agg_field] = api_agg;
            } else {
                resp_agg[agg_field] = {
                    [agg_type]: api_agg
                };
            }
        }

        return resp_agg;
    }
}

export default baseFilter;